<template>
  <div class="login-register-container">
    <!-- 切换标签 -->
    <div class="tab-switch">
      <div 
        :class="['tab-item', activeTab === 'login' ? 'tab-active' : '']"
        @click="switchTab('login')"
      >
        登录
      </div>
      <div 
        :class="['tab-item', activeTab === 'register' ? 'tab-active' : '']"
        @click="switchTab('register')"
      >
        注册
      </div>
    </div>

    <!-- 登录表单 -->
    <div v-if="activeTab === 'login'" class="form-container">
      <div class="form-header">
        <h2>欢迎回来</h2>
        <p>登录您的账户继续使用门头设计助手</p>
      </div>
      
      <el-form
        ref="loginFormRef"
        :model="loginForm"
        :rules="loginRules"
        label-position="top"
        @submit.prevent="handleLogin"
        class="form-content"
        hide-required-asterisk
      >
        <el-form-item label="用户名/手机号" prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名或手机号"
            :prefix-icon="User"
            size="large"
          />
        </el-form-item>
        
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="loginForm.password"
            placeholder="请输入密码"
            :prefix-icon="Lock"
            :type="showLoginPassword ? 'text' : 'password'"
            size="large"
          >
            <template #suffix>
              <el-icon 
                class="password-toggle"
                @click="showLoginPassword = !showLoginPassword"
              >
                <View v-if="showLoginPassword" />
                <Hide v-else />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        
        <div class="form-options">
          <el-checkbox v-model="loginForm.rememberMe" label="记住我" />
        </div>
        
        <el-form-item>
          <el-button
            type="primary"
            native-type="submit"
            :loading="isLogging"
            class="submit-btn"
            size="large"
          >
            {{ isLogging ? '登录中...' : '立即登录' }}
          </el-button>
        </el-form-item>
        
        <div class="login-link">
          还没有账户？
          <el-link type="success" @click="switchTab('register')">立即注册</el-link>
        </div>
      </el-form>
    </div>

    <!-- 注册表单 -->
    <div v-else class="form-container">
      <div class="form-header">
        <h2>创建新账户</h2>
        <p>注册账户，开启您的门头设计之旅</p>
      </div>
      
      <el-form
        ref="registerFormRef"
        :model="registerForm"
        :rules="registerRules"
        label-position="top"
        @submit.prevent="handleRegister"
        class="form-content"
        hide-required-asterisk
      >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="registerForm.username"
            placeholder="请输入用户名（2-10个字符）"
            :prefix-icon="User"
            size="large"
          />
        </el-form-item>
        
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="registerForm.phone"
            placeholder="请输入手机号"
            :prefix-icon="Iphone"
            size="large"
          />
        </el-form-item>
        
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="registerForm.password"
            placeholder="请输入密码（6-20位字符）"
            :prefix-icon="Lock"
            :type="showRegisterPassword ? 'text' : 'password'"
            size="large"
          >
            <template #suffix>
              <el-icon 
                class="password-toggle"
                @click="showRegisterPassword = !showRegisterPassword"
              >
                <View v-if="showRegisterPassword" />
                <Hide v-else />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="registerForm.confirmPassword"
            placeholder="请再次输入密码"
            :prefix-icon="Lock"
            :type="showConfirmPassword ? 'text' : 'password'"
            size="large"
          >
            <template #suffix>
              <el-icon 
                class="password-toggle"
                @click="showConfirmPassword = !showConfirmPassword"
              >
                <View v-if="showConfirmPassword" />
                <Hide v-else />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        
        <el-form-item prop="agreed">
          <el-checkbox v-model="registerForm.agreed">
            我已阅读并同意
            <el-link type="info" @click="showAgreement">《用户服务协议》</el-link>
            和
            <el-link type="info" @click="showPrivacy">《隐私政策》</el-link>
          </el-checkbox>
        </el-form-item>
        
        <el-form-item>
          <el-button
            type="success"
            native-type="submit"
            :loading="isRegistering"
            class="submit-btn"
            size="large"
          >
            {{ isRegistering ? '注册中...' : '立即注册' }}
          </el-button>
        </el-form-item>
        
        <div class="login-link">
          已有账户？
          <el-link type="success" @click="switchTab('login')">立即登录</el-link>
        </div>
      </el-form>
    </div>


    <!-- 用户协议弹窗 -->
    <el-dialog
      v-model="showAgreementDialog"
      title="用户服务协议"
      width="600px"
      class="agreement-dialog"
      :append-to-body="true"
    >
      <div class="agreement-content">
        <h3>用户服务协议</h3>
        <p>欢迎使用门头店铺设计助手服务！</p>
        <p>在注册成为我们的用户前，请仔细阅读以下条款：</p>
        <ul>
          <li>用户应保证提供的信息真实、准确、完整</li>
          <li>用户对使用本服务所产生的设计成果享有相应权利</li>
          <li>不得利用本服务从事任何违法或侵权活动</li>
          <li>我们有权根据业务需要调整服务内容</li>
        </ul>
        <p>本协议最终解释权归门头店铺设计助手所有。</p>
      </div>
      <template #footer>
        <el-button type="primary" @click="showAgreementDialog = false">我已阅读</el-button>
      </template>
    </el-dialog>

    <!-- 隐私政策弹窗 -->
    <el-dialog
      v-model="showPrivacyDialog"
      title="隐私政策"
      width="600px"
      class="privacy-dialog"
      :append-to-body="true"
    >
      <div class="privacy-content">
        <h3>隐私政策</h3>
        <p>我们非常重视您的隐私保护，特此说明：</p>
        <ul>
          <li>我们仅收集必要的用户信息用于提供服务</li>
          <li>您的个人信息将受到严格保密</li>
          <li>未经您同意，我们不会向第三方透露您的信息</li>
          <li>您有权随时查询、修改或删除您的个人信息</li>
        </ul>
        <p>如有任何疑问，请通过联系我们页面与我们沟通。</p>
      </div>
      <template #footer>
        <el-button type="primary" @click="showPrivacyDialog = false">我已阅读</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, defineProps, defineEmits, watch } from 'vue'
import { 
  User, Lock, View, Hide, Iphone
} from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'

// 定义props和emits
const props = defineProps({
  defaultTab: {
    type: String,
    default: 'login'
  }
});

const emit = defineEmits(['login-success']);

// 使用store
const store = useStore();

// 当前活动标签页
const activeTab = ref(props.defaultTab);

// 监听props变化
watch(() => props.defaultTab, (newTab) => {
  if (newTab && newTab !== activeTab.value) {
    switchTab(newTab);
  }
});

// 表单引用
const loginFormRef = ref()
const registerFormRef = ref()

// 登录表单数据
const loginForm = reactive({
  username: '',
  password: '',
  rememberMe: false
})

// 注册表单数据
const registerForm = reactive({
  username: '',
  phone: '',
  password: '',
  confirmPassword: '',
  verificationCode: '',
  agreed: false
})



// 登录表单验证规则
const loginRules = reactive({
  username: [
    { required: true, message: '请输入用户名或手机号', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
  ]
})

// 注册表单验证规则
const registerRules = reactive({
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 2, max: 10, message: '用户名长度应为2-10个字符', trigger: 'blur' }
  ],
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度应为6-20位字符', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请再次输入密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== registerForm.password) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  agreed: [
    {
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error('请同意用户协议和隐私政策'))
        } else {
          callback()
        }
      },
      trigger: 'change'
    }
  ]
})

// 控制密码显示/隐藏
const showLoginPassword = ref(false)
const showRegisterPassword = ref(false)
const showConfirmPassword = ref(false)

// 加载状态
const isLogging = ref(false)
const isRegistering = ref(false)

// 弹窗控制
const showAgreementDialog = ref(false)
const showPrivacyDialog = ref(false)

// 切换标签页
const switchTab = (tab) => {
  activeTab.value = tab
  // 重置表单验证
  if (loginFormRef.value) {
    loginFormRef.value.clearValidate()
  }
  if (registerFormRef.value) {
    registerFormRef.value.clearValidate()
  }
}

// 暴露方法给父组件
defineExpose({
  switchTab
});

// 处理登录
const handleLogin = async () => {
  if (!loginFormRef.value) return
  
  try {
    await loginFormRef.value.validate()
    
    isLogging.value = true
    
    // 调用登录API
    const loginData = {
      username: loginForm.username,
      password: loginForm.password,
      rememberMe: loginForm.rememberMe
    }
    
    const response = await store.dispatch('login', loginData)
    console.log(response,'2123123');
    
    // 登录成功后获取用户详情
    try {
      await store.dispatch('getCurrentUser')
    } catch (error) {
      console.log('获取用户详情失败:', error)
    }
    
    isLogging.value = false
    
    ElMessage({
      message: '登录成功！',
      type: 'success',
      duration: 2000
    })
    
    console.log('登录响应数据:', response)
    
    // 发送登录成功事件
    emit('login-success')
    
    // 如果选择了记住我，可以保存到localStorage
    if (loginForm.rememberMe) {
      localStorage.setItem('rememberedUser', loginForm.username)
    }
  } catch (error) {
    isLogging.value = false
    console.log('登录失败:', error)
    ElMessage({
      message: error.response?.data?.message || '登录失败，请检查用户名和密码',
      type: 'error',
      duration: 2000
    })
  }
}

// 处理注册
const handleRegister = async () => {
  if (!registerFormRef.value) return
  
  try {
    await registerFormRef.value.validate()
    
    isRegistering.value = true
    
    // 调用注册API
    const registerData = {
      username: registerForm.username,
      phone: registerForm.phone,
      password: registerForm.password,
      confirmPassword: registerForm.confirmPassword,
      agreed: registerForm.agreed
    }
    
    const response = await store.dispatch('register', registerData)
    
    isRegistering.value = false
    
    ElMessage({
      message: '注册成功！',
      type: 'success',
      duration: 2000
    })
    
    console.log('注册响应数据:', response)
    
    // 注册成功后自动切换到登录页面
    switchTab('login')
    
    // 清空注册表单
    Object.keys(registerForm).forEach(key => {
      if (key !== 'agreed') {
        registerForm[key] = ''
      }
    })
    registerForm.agreed = false
  } catch (error) {
    isRegistering.value = false
    console.log('注册失败:', error)
    ElMessage({
      message: error.response?.data?.message || '注册失败，请稍后重试',
      type: 'error',
      duration: 2000
    })
  }
}

// 显示用户协议
const showAgreement = () => {
  showAgreementDialog.value = true
}

// 显示隐私政策
const showPrivacy = () => {
  showPrivacyDialog.value = true
}
</script>

<style scoped lang="less">
.login-register-container {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  background: #000;
  
  .tab-switch {
    display: flex;
    margin-bottom: 30px;
    border-bottom: 1px solid #2B2C2C;
    
    .tab-item {
      flex: 1;
      text-align: center;
      padding: 15px 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
      cursor: pointer;
      transition: all 0.3s ease;
      opacity: 0.7;
      
      &:hover {
        opacity: 1;
        color: #5EFF00;
      }
    }
    
    .tab-active {
      color: #5EFF00 !important;
      opacity: 1;
      border-bottom: 2px solid #5EFF00;
    }
  }
  
  .form-container {
    .form-header {
      text-align: center;
      margin-bottom: 30px;
      
      h2 {
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: bold;
        font-size: 24px;
        color: #FFFFFF;
        margin-bottom: 10px;
      }
      
      p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #AAAAAA;
      }
    }
    
    .form-content {
      :deep(.el-form-item) {
        margin-bottom: 24px;
        
        .el-form-item__label {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
          padding-bottom: 8px;
        }
        
        .el-input {
          .el-input__wrapper {
            background: #1A1A1A;
            border: 1px solid #2B2C2C;
            border-radius: 6px;
            box-shadow: none;
            transition: all 0.3s ease;
            
            &:hover {
              border-color: #5EFF00;
            }
            
            &.is-focus {
              border-color: #5EFF00;
              box-shadow: 0 0 0 1px rgba(94, 255, 0, 0.1);
            }
          }
          
          .el-input__inner {
            color: #FFFFFF;
            font-family: PingFang SC, PingFang SC;
            font-size: 14px;
            
            &::placeholder {
              color: #666666;
            }
          }
          
          .el-input__prefix, .el-input__suffix {
            color: #666666;
            
            .el-icon {
              font-size: 16px;
            }
          }
          
          .password-toggle {
            cursor: pointer;
            color: #666666;
            transition: color 0.3s ease;
            
            &:hover {
              color: #5EFF00;
            }
          }
        }
        
        .el-form-item__error {
          color: #ff4d4f;
          font-size: 12px;
          padding-top: 4px;
        }
      }
      
      .form-options {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
        
        :deep(.el-checkbox) {
          .el-checkbox__label {
            color: #FFFFFF;
            font-size: 14px;
          }
          
          .el-checkbox__inner {
            background-color: #1A1A1A;
            border-color: #2B2C2C;
            
            &:hover {
              border-color: #5EFF00;
            }
          }
          
          &.is-checked {
            .el-checkbox__inner {
              background-color: #5EFF00;
              border-color: #5EFF00;
            }
          }
        }
        
        :deep(.el-link) {
          font-size: 14px;
          color: #5EFF00;
          
          &:hover {
            color: #7AFF33;
          }
        }
      }
      
      .submit-btn {
        width: 100%;
        height: 48px;
        border-radius: 6px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        border: none;
        transition: all 0.3s ease;
        background: #5EFF00;
        color: #000;
        
        &:hover {
          opacity: 0.9;
          transform: translateY(-1px);
          background: #7AFF33;
        }
        
        &:active {
          transform: translateY(0);
        }
        
        // 登录按钮样式
        &.el-button--primary {
          background: #5EFF00;
          border-color: #5EFF00;
          color: #000;
          
          &:hover {
            background: #7AFF33;
            border-color: #7AFF33;
          }
        }
        
        // 注册按钮样式
        &.el-button--success {
          background: #5EFF00;
          border-color: #5EFF00;
          color: #000;
          
          &:hover {
            background: #7AFF33;
            border-color: #7AFF33;
          }
        }
      }
      
      .login-link {
        text-align: center;
        font-size: 14px;
        color: #AAAAAA;
        margin-top: 20px;
        
        :deep(.el-link) {
          font-size: 14px;
          margin-left: 5px;
          color: #5EFF00;
          
          &:hover {
            color: #7AFF33;
          }
        }
      }
    }
  }
}

// 弹窗样式
:deep(.forgot-password-dialog),
:deep(.agreement-dialog),
:deep(.privacy-dialog) {
  .el-dialog {
    background: #000 !important;
    border-radius: 12px;
    border: 1px solid #333;
    
    .el-dialog__header {
      border-bottom: 1px solid #333;
      padding: 20px 20px 15px;
      
      .el-dialog__title {
        color: #FFFFFF;
        font-size: 18px;
        font-weight: bold;
      }
      
      .el-dialog__headerbtn {
        top: 20px;
        right: 20px;
        
        .el-dialog__close {
          color: #666666;
          font-size: 20px;
          
          &:hover {
            color: #5EFF00;
          }
        }
      }
    }
    
    .el-dialog__body {
      padding: 20px;
      color: #FFFFFF;
      
      .dialog-tip {
        color: #AAAAAA;
        margin-bottom: 20px;
        font-size: 14px;
      }
      
      .agreement-content, .privacy-content {
        h3 {
          color: #FFFFFF;
          margin-bottom: 15px;
          font-size: 16px;
        }
        
        p {
          color: #AAAAAA;
          margin-bottom: 10px;
          line-height: 1.6;
          font-size: 14px;
        }
        
        ul {
          color: #AAAAAA;
          padding-left: 20px;
          margin-bottom: 15px;
          
          li {
            margin-bottom: 8px;
            line-height: 1.5;
            font-size: 14px;
          }
        }
      }
    }
    
    .el-dialog__footer {
      border-top: 1px solid #333;
      padding: 20px;
      
      .dialog-footer {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
      }
    }
  }
}

// 响应式调整
@media (max-width: 768px) {
  .login-register-container {
    padding: 15px;
    max-width: 100%;
    
    .tab-switch {
      .tab-item {
        font-size: 16px;
        padding: 12px 0;
      }
    }
    
    .form-container {
      .form-header {
        h2 {
          font-size: 20px;
        }
        
        p {
          font-size: 13px;
        }
      }
      
      .form-options {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
      }
    }
  }
}

@media (max-width: 480px) {
  .login-register-container {
    padding: 10px;
    
    .tab-switch {
      .tab-item {
        font-size: 14px;
        padding: 10px 0;
      }
    }
    
    .form-container {
      .form-header {
        h2 {
          font-size: 18px;
        }
        
        p {
          font-size: 12px;
        }
      }
    }
  }
  
  :deep(.forgot-password-dialog),
  :deep(.agreement-dialog),
  :deep(.privacy-dialog) {
    .el-dialog {
      margin: 10px;
      max-width: calc(100vw - 20px);
      
      .el-dialog__header {
        padding: 15px 15px 10px;
        
        .el-dialog__title {
          font-size: 16px;
        }
      }
      
      .el-dialog__body {
        padding: 15px;
        
        .agreement-content, .privacy-content {
          h3 {
            font-size: 14px;
          }
          
          p, li {
            font-size: 12px;
          }
        }
      }
      
      .el-dialog__footer {
        padding: 15px;
      }
    }
  }
}
</style>